/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Modal } from 'react-bootstrap';
import { KTIcon } from '../../../_metronic/helpers';
import CurrencyFormat from 'react-currency-format';
import './Deal.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { showToastMessageError } from '../../modules/Toast-Message/TosatMessage';
import { AddCommits } from './AddCommits';
import { AddTracking } from './AddTracking';
import { Send } from 'react-ionicons'



const modalsRoot = document.getElementById('root-modals') || document.body;

const Details = ({ show2, handleClose2, propsData2, showCreateAppModalCommit, setShowCreateAppModalCommit, showCreateAppModalTracking, setShowCreateAppModalTracking, setChangedColor, setChangedSize }) => {
    const [dealDetail, setDealDeatils] = useState(propsData2?.default_color);
    const [selectedID, setSelectedID] = useState(propsData2?.default_color?.attribute_code);
    const [selectedAttrSizes,setSelectedAttrSizes] = useState(propsData2?.default_color?.sizes);
    const [sizeDetail, setSizeDeatils] = useState(propsData2?.default_color?.sizes[0]);
    const [selectedSizeID, setSelectedSizeID] = useState(propsData2?.default_color?.sizes[0].size);
    const totalPrice = (parseFloat(dealDetail.price) + parseFloat(dealDetail.commission)).toFixed(2);

    console.log(dealDetail)

    const userDetails = localStorage.getItem('kt-auth-react-v');
    const myUser = JSON.parse(userDetails);

    const formatDate = (myDate) =>{
      const date = new Date(myDate);
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const day = String(date.getDate()).padStart(2, '0');
      const year = date.getFullYear();
    
      return `${month}-${day}-${year}`;
    }

    useEffect(() => {
      console.log('Commit Modal:', showCreateAppModalCommit);
      console.log('Tracking Modal:', showCreateAppModalTracking);
        if (showCreateAppModalCommit) {
            handleClose2();
        }
        if (showCreateAppModalTracking) {
            handleClose2();
            console.log('Tracking Modal Closed by useEffect')
        }
    }, [showCreateAppModalCommit,showCreateAppModalTracking]);

    useEffect(() => {
        setChangedColor(dealDetail);
    }, [dealDetail]);

    useEffect(() => {
        setChangedSize(sizeDetail);
    }, [sizeDetail]);

    //     <AddCommits
    //     show={showCreateAppModalCommit}
    //     propsData={propsData2}
    //     // imgPath={toAbsoluteUrl('/media/images/1.png')}
    //     handleClose={() => {
    //         setShowCreateAppModalCommit(false);
    //     }}
    //     changedColor={dealDetail.attribute_code}
    //     changedColor2={dealDetail.color}
    //     changePrice={dealDetail.price}
    // />

    const commitFun = () => {
      showToastMessageError('Commitment Full')
    }

    // const formatDate = (myDate) =>{
    //   const formattedDate = myDate.slice(0,10);
    //   return formattedDate
    // }

    const getBelowCostPercentage = (currentPrice,actualPrice)=>{
      const percentChange = (((currentPrice - actualPrice) / actualPrice) * 100).toFixed(2);
      const display = (percentChange > 0 ? '+' : '') + percentChange + '%';
      return display;
    }

    return createPortal(
      <>
      <style>{`
        .border-prime__{
        border:'10px solid #59dce6' !important
        }

        #kt_modal_create_app .modal-content{
        border-radius:20px;
        }
        
        #kt_modal_create_app__ .modal-content {
        position: relative;
        border: 10px solid #59dce6 !important;
        border-radius: 20px;
        overflow: hidden;
        padding-right: 85px; /* reserve space for image */
      }

      #kt_modal_create_app__ .modal-content::after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        width: 85px;
        height: 100%;
        background: url("https://makemoneyormiles.com/media/images/primebigday-sider-2026.png") center center no-repeat;
        background-size: cover;
      }
        .mw-1000px{
          max-width: 1000px !important;
        }
        
      `}</style>
      <Modal
        id='kt_modal_create_app'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog modal-dialog-centered mw-900px'
        // dialogClassName='modal-dialog modal-dialog-centered mw-1000px'
        // contentClassName="border-prime__"
        show={show2}
        onHide={handleClose2}
        backdrop={true}
      >
        <div
          className='btn btn-sm btn-icon btn-active-color-primary'
          style={{marginLeft: 'auto'}}
          onClick={handleClose2}
        >
          <KTIcon className='fs-1' iconName='cross' />
        </div>
        <ToastContainer />
        {propsData2.business_deal == 1 && (
                <div className="biz-deal-label"
                style={{
                  position: 'absolute',
                  top: '0px',
                  right: '75px',
                  backgroundColor: 'rgba(255, 255, 255, 1)',
                  border: '2px solid rgb(207, 222, 255)',
                  borderTop: '0',
                  color: '#000000',
                  padding: '10px 10px 15px 10px',
                  zIndex:5,
                  borderRadius: '0 0 15px 15px',
                }}
                >
                  <div className='d-flex flex-column align-items-center justify-content-center'>
                    <i class="bi bi-bookmark-star-fill" style={{fontSize:30,color:'#0033a1ff'}}></i>
                    <span style={{fontSize:15}}>Business</span>
                  </div>
                </div>
              )}
        <div>
          <div className='card mt-5'>

            <div className='ribbon ribbon-start ribbon-clip' style={{top: '10px'}}>
              {propsData2.status === 1 ? (
                <div className='ribbon-label' style={{paddingLeft:25}}>
                  {propsData2.deal_stock == 'true' ? 'In Stock' : 'Commitment Full'}
                  {propsData2.deal_stock == 'true' ? (
                    <span className='ribbon-inner bg-info'></span>
                  ) : (
                    <span className='ribbon-inner bg-danger'></span>
                  )}
                </div>
              ) : (
                <div className='ribbon-label'>
                  Expired
                  <span className='ribbon-inner bg-warning'></span>
                </div>
              )}
            </div>
            
            <div className='row col-12'>
              <div className="col-lg-4 col-md-12">
              <div className='card-body d-flex flex-column justify-content-between'>
                <div className={`card-rounded text-center`}>
                  <img
                    src={dealDetail.image ? dealDetail.image : propsData2?.default_color?.image}
                    alt=''
                    style={{width: '200px', height: 'auto'}}
                  />
                </div>

                <div className='row border border-gray-300 border-dashed rounded py-3 px-3 d-none d-lg-block'>
                  <h5><span className='fw-semibold text-muted'>Committed Qty :</span> {propsData2?.user_commited_qty}</h5>
                  <hr />
                  <div className="col-6">
                    <div className=''>
                      <div className='fs-4 fw-bold text-gray-700'>
                        <span className='w-50px'>{propsData2?.user_pending_commit}</span>
                      </div>
                      <div className='fw-semibold text-muted'>Pending</div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className=''>
                      <div className='fs-4 fw-bold text-gray-700'>
                        <span className='w-50px'>{propsData2?.user_tracking_qty}</span>
                      </div>
                      <div className='fw-semibold text-muted'>On Tracking</div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

              <div className='col-lg-8 col-md-12'>
                <div className='mb-5'>
                  <div className='d-flex flex-wrap'>
                    {sizeDetail?.stock ? (
                    <div className='border border-gray-300 border-dashed rounded py-3 px-3 mb-3'>
                      <div className='fs-4 fw-bold text-gray-700'>
                        <span className='w-75px'>{Math.max(sizeDetail?.stock - sizeDetail?.commited_qty, 0)}</span>
                      </div>
                      <div className='fw-semibold text-muted'>Available Qty</div>
                    </div>
                    ) : (
                      <div className='border border-gray-300 border-dashed rounded py-3 px-3 mb-3'>
                      <div className='fs-4 fw-bold text-gray-700'>
                        <span className='w-75px'>0</span>
                      </div>
                      <div className='fw-semibold text-muted'>Available Qty</div>
                    </div>
                    )}

                    <div className='border border-gray-300 border-dashed rounded py-3 px-3 mb-3 mx-3'>
                      <div className='fs-4 fw-bold text-gray-700'>
                        <span className='w-75px'>{propsData2.user_limit}</span>
                      </div>
                      <div className='fw-semibold text-muted'>Maximum Order Limit</div>
                    </div>

                    


                  </div>
                  <div className='mt-2 mx-5 mx-lg-0'>
                    <div className='card-rounded p-2 z-index-1 bg-body'>
                      <div
                        className='shadow-xs align-items-center'
                        style={{marginLeft: '-15px', marginTop: '-15px', padding: '10px'}}
                      >
                        <div className='d-flex align-items-center flex-wrap w-100'>
                          <div className='pe-3 flex-grow-1'>
                          <h5 className="mt-3">Deal ID : <u>{propsData2?.deal_no}</u></h5>
                            <h4><a href='#' className='fs-4 fw-bold text-gray-700 text-hover-dark mt-3'>
                              <strong>
                                {propsData2?.name}-{dealDetail.color}&nbsp;{(sizeDetail.size != 'OS') ? sizeDetail.size_name : ''}
                              </strong>
                            </a></h4>
                            
                            <div className='d-flex align-items-center mt-5'>
                              <div className='me-5'>
                                <div className='fs-5 symbol-label'>Model:</div>
                                <div className='fs-5 symbol-label'>Deal Expires:</div>
                                <div className='fs-5 symbol-label'>Price:</div>
                                  <div className='fs-5 symbol-label'>Commission:</div>
                                <div className='fs-5 fw-bold symbol-label'>Total:</div>
                              </div>
                              <div className=''>
                                <div className='fs-5 text-gray-800 pe-1'>{dealDetail.model}</div>
                                <div className='fs-5 text-gray-800 pe-1'>{formatDate(propsData2?.expires)}</div>
                                <div className='fs-5 text-gray-800 pe-1'>
                                  <CurrencyFormat
                                    decimalScale={2}
                                    value={Number(sizeDetail.price).toFixed(2)}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'$'}
                                  />
                                  {(propsData2.below_cost == 1) && (
                                  <span className='text-muted text-decoration-line-through ms-3'>
                                  <CurrencyFormat
                                    decimalScale={2}
                                    value={Number(sizeDetail.commission).toFixed(2)}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'$'}
                                  />
                                  </span>
                                  )}
                                  {(propsData2.below_cost == 1 && sizeDetail.commission != 0) && (
                                    <span className="fs-8 py-1 px-2 ms-2" style={{color:'#ffffffff',borderRadius:8,backgroundColor:'#ff8484ff'}}>{getBelowCostPercentage(Number(sizeDetail.price),sizeDetail.commission)}</span>
                                      )}
                                </div>
                                  <div className='fs-5 text-gray-800 pe-1'>
                                    <CurrencyFormat
                                      decimalScale={2}
                                      value={(propsData2.commission_status == 1) ? sizeDetail.commission.toFixed(2) : '0.00'}
                                      displayType={'text'}
                                      thousandSeparator={true}
                                      prefix={'$'}
                                    />
                                  </div>

                                <div className='fw-bold fs-5 text-gray-800 pe-1'>
                                  <CurrencyFormat
                                    decimalScale={2}
                                    value={Number(sizeDetail.total).toFixed(2)}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'$'}
                                  />
                                </div>
                              </div>
                            </div>
                            <div>
                              {(selectedAttrSizes.length > 1) && (selectedAttrSizes[0].size != 'OS') && (
                              <ul className='deal_sizes'>
                                <div className='mt-3 fs-5 mb-2'>Sizes Available:</div>
                                
                                {selectedAttrSizes.map((item, index) => {
                                  return (
                                    <li
                                      key={index}
                                      onClick={() => {
                                        setSizeDeatils(item)
                                        setSelectedSizeID(item.size)
                                      }}
                                    >
                                      
                                      <button className={item.size == selectedSizeID
                                            ? 'size-btn-selected'
                                            : 'size-btn'
                                        }>
                                        <span className='sizeBox mx-2'>{item.size_name}</span>
                                      </button>
                                    </li>
                                  )
                                })}
                              </ul>
                              )}
                              <ul className='deal_colors'>
                                <div className='mt-3 fs-5 mb-2'>Color Available:</div>
                                {propsData2?.colors.map((item, index) => {
                                  return (
                                    <li
                                      key={index}
                                      onClick={() => {
                                        setDealDeatils(item)
                                        setSelectedID(item.attribute_code)
                                        setSelectedAttrSizes(item.sizes)
                                        setSizeDeatils(item.sizes[0])
                                        setSelectedSizeID(item.sizes[0].size)
                                      }}
                                    >
                                      <div
                                        className={
                                          item.attribute_code == selectedID
                                            ? 'color-item deal_colors_selected'
                                            : 'color-item deal_colors_select'
                                        }
                                        style={{borderColor: `${item.color_code}`}}
                                      >
                                        <div
                                          className='colorBox'
                                          style={{background: `${item.color_code}`,border:'2px solid black'}}
                                        ></div>
                                      </div>
                                    </li>
                                  )
                                })}
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div className='mt-5'>
                          <div className='d-flex align-items-center col-12'>
                            <div className='col-12 d-flex'>
                              {/* <div className='mt-3 fs-5 '></div> */}
                              <div  className='mt-3 fs-5'>Shipping Location : {propsData2?.shipping_address} - 
                                <span>{propsData2?.shipping_zipcode}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="border-top border-2 my-2"></div>
                        <div className='d-flex'>
                            {sizeDetail.stores.map((item, index) => {
                              return (
                                <a
                                  key={index}
                                  href={item?.store_url}
                                  target='_blank'
                                  className='symbol symbol-40px me-2 card shadow-xs p-1'
                                  style={{borderRadius:'50%'}}
                                  data-bs-toggle='tooltip'
                                  title={item?.store?.name}
                                >
                                  <img
                                    src={item?.store?.image}
                                    alt='store'
                                    style={{height: '30px', width: ' 30px'}}
                                  />
                                </a>
                              )
                            })}
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
                  
                <p className='fs-5 ms-5'><i class="fa-solid fa-bullhorn me-2 text-dark fa-3x"></i><b>Note</b> :- {propsData2?.note ? propsData2?.note : 'There is nothing'}</p>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className='d-flex justify-content-between'>
          <div className='' style={{paddingRight: '10px', paddingBottom: '10px'}}>
            <button onClick={handleClose2} type='button' className='btn btn-danger  mx-5'>
              Close
            </button>
          </div>
          <div className=' ' style={{paddingRight: '10px', paddingBottom: '10px'}}>
            {propsData2.status != 2 && propsData2.freezed_status == 0 && (
              Math.max(dealDetail?.stock - dealDetail?.commited_qty, 0) != 0 ? (
              <>
              <button
                onClick={() => {
                   setShowCreateAppModalTracking(true)
                }}
                type='button'
                className='btn btn-success fw-bold me-0 me-lg-2'
              >
                Track&nbsp;&nbsp;<Send color={'white'} height="15px" width="15px" />
              </button>
              <button
                onClick={() => {
                   setShowCreateAppModalCommit(true)
                }}
                type='button'
                className='btn btn-warning fw-bold'
              >
                Commit&nbsp;&nbsp;<Send color={'white'} height="15px" width="15px" />
              </button>
              </>
              ) : (
              <>
              <button
                onClick={() => {
                  commitFun()
                }}
                type='button'
                className='btn btn-secondary fw-bold me-5'
              >
                Track&nbsp;&nbsp;<Send color={'white'}  height="15px" width="15px" />
              </button>
              <button
                onClick={() => {
                  commitFun()
                }}
                type='button'
                className='btn btn-secondary fw-bold'
              >
                Commit&nbsp;&nbsp;<Send color={'white'}  height="15px" width="15px" />
              </button>
              </>
              )
            )}
          </div>
        </div>
      </Modal>
      </>,
      modalsRoot
    )
}

export { Details };
